import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ShareLinkActions {
  SET_SHARE_LINK = '@APP/SET_SHARE_LINK'
}

export const INITIAL_SHARE_LINK_STATE: string = '';

const shareLinkSlice = createSlice({
  name: ShareLinkActions.SET_SHARE_LINK,
  initialState: INITIAL_SHARE_LINK_STATE,
  reducers: {
    setShareLink: (state, action: PayloadAction<string>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  }
});

export const { setShareLink } = shareLinkSlice.actions;

export const shareLinkReducer = shareLinkSlice.reducer;
